module.exports = __webpack_public_path__ + "img/brand-pic2-04.b4382721.png";